// ABOUTME: PocketBase filter escaping utility to prevent SQL injection
// ABOUTME: Escapes special characters in filter values for safe PocketBase queries

/**
 * Escape special characters in PocketBase filter values to prevent SQL injection
 * @param {string} value - The value to escape
 * @returns {string} - Escaped value safe for use in PocketBase filters
 */
export function escapeFilterValue(value) {
  if (value === null || value === undefined) {
    return '';
  }

  // Convert to string
  const str = String(value);

  // Escape backslashes first (must be first to avoid double-escaping)
  // Then escape double quotes
  return str
    .replace(/\\/g, '\\\\')
    .replace(/"/g, '\\"');
}

/**
 * Create a safe PocketBase filter with escaped values
 * Usage: safeFilter`userId = "${userId}"`
 * @param {Array<string>} strings - Template literal strings
 * @param {...any} values - Values to escape and interpolate
 * @returns {string} - Safe filter string
 */
export function safeFilter(strings, ...values) {
  let result = '';

  for (let i = 0; i < strings.length; i++) {
    result += strings[i];

    if (i < values.length) {
      result += escapeFilterValue(values[i]);
    }
  }

  return result;
}

export default { escapeFilterValue, safeFilter };
